import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TableCell } from '@nagel-types';

@Component({
    selector: 'app-unsupported-cell',
    templateUrl: './unsupported-cell.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnsupportedCellComponent {
    cell = input.required<TableCell>();
}
